import { useMutation } from '@tanstack/react-query'
import { ApiQueryKeys } from 'globals/constants'
import { useSnackbar } from 'notistack'
import { AccountApi, SubAccountStatusUpdatePayload } from 'sdk'

export const useSubAccountStatusUpdateStatus = () => {
  const accountApi = new AccountApi()
  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync: updateSubAccountStatus, isPending: isUpdating } = useMutation({
    mutationKey: [ApiQueryKeys.account.updateSubAccountStatus],
    mutationFn: (data: SubAccountStatusUpdatePayload) => accountApi.updateSubAccountStatus(data),
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => enqueueSnackbar('Access Changed', { variant: 'success' }),
  })
  return {
    updateSubAccountStatus,
    isUpdating,
  }
}
